import { Paragraph, Table, TableRow, TableCell } from "docx";
import { formatFloats } from "./published-model-helpers";

export const createCoaTable = (costOfAttendance) => {
  // Create table header row
  const coaHeaderRow = new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("")],
      }),
      new TableCell({
        children: [new Paragraph("Last Year")],
      }),
      new TableCell({
        children: [new Paragraph("Current Year")],
      }),
      new TableCell({
        children: [new Paragraph("% Change")],
      }),
    ],
  });

  // Create data rows from costOfAttendance array
  const coaDataRows = costOfAttendance.map(
    (item) =>
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph(item.type)],
          }),
          new TableCell({
            children: [new Paragraph(formatFloats(item.lastYear, "currency"))],
          }),
          new TableCell({
            children: [
              new Paragraph(formatFloats(item.currentYear, "currency")),
            ],
          }),
          new TableCell({
            children: [
              new Paragraph(formatFloats(item.percentChange, "percentage")),
            ],
          }),
        ],
      })
  );

  return new Table({
    rows: [coaHeaderRow, ...coaDataRows],
  });
};
